import styled from 'styled-components';

const colors = {
  default: '#6C727F',
  primary: '#0078D4',
  success: '#0E9F6E',
};

const sizes = {
  tiny: '0.25em',
  small: '0.5em',
  normal: '1em',
  large: '2em',
  huge: '3em',
};

export enum IconAppearance {
  Default = 'default',
  Primary = 'primary',
  Success = 'success',
}

type IconSize = 'tiny' | 'small' | 'normal' | 'large' | 'huge';

interface StyledIconProps {
  appearance?: IconAppearance;
  size?: IconSize;
}

const Icon = styled.span<StyledIconProps>`
  color: ${props => (props.appearance ? colors[props.appearance] : IconAppearance.Default)};
  font-size: ${props => (props.size ? sizes[props.size] : sizes.normal)};
`;

export default Icon;
